/* Meera Capsule — complimentary sample picker behaviour (2026-10-04).
   See snippets/cart-sample-picker.liquid. */
(function () {
  if (window.__meeraSamplesInit) return;
  window.__meeraSamplesInit = true;

  var cfg = window.meeraSamples || { tier2: 0 };
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = false;
  var BUBBLES = [
    ['header', 'cart-icon-bubble-header'],
    ['menu-drawer', 'cart-icon-bubble-menu-drawer'],
    ['secondary-sidebar', 'cart-icon-bubble-secondary-sidebar'],
    ['main-sidebar', 'cart-icon-bubble-main-sidebar'],
    ['secondary-header', 'cart-icon-bubble-secondary-header']
  ];

  function isSample(i) { return String(i.product_type || '').toLowerCase() === 'sample'; }
  function onCartPage() { return /\/cart\/?$/.test(window.location.pathname); }

  function allowanceFor(cart) {
    var paid = cart.items.filter(function (i) { return !isSample(i); });
    if (!paid.length) return 0;
    var sub = paid.reduce(function (s, i) { return s + i.final_line_price; }, 0);
    return cfg.tier2 > 0 && sub >= cfg.tier2 ? 2 : 1;
  }

  function getCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function render(state) {
    if (!state || !state.sections) return;
    var html = state.sections['cart-drawer'];
    if (html) {
      var src = new DOMParser().parseFromString(html, 'text/html').querySelector('#CartDrawer');
      if (src) document.querySelectorAll('#CartDrawer').forEach(function (el) { el.innerHTML = src.innerHTML; });
      var drawer = document.querySelector('cart-drawer');
      if (drawer) drawer.classList.toggle('is-empty', state.item_count === 0);
    }
    BUBBLES.forEach(function (b) {
      var s = state.sections[b[0]];
      var el = document.getElementById(b[1]);
      if (!s || !el) return;
      var src = new DOMParser().parseFromString(s, 'text/html').getElementById(b[1]);
      if (src) el.innerHTML = src.innerHTML;
    });
  }

  function update(updates) {
    var sections = ['cart-drawer'];
    BUBBLES.forEach(function (b) { if (document.getElementById(b[1])) sections.push(b[0]); });
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates, sections: sections.slice(0, 5), sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (onCartPage()) { window.location.reload(); return state; }
        render(state);
        return state;
      });
  }

  // Keep samples within the allowance; drop them when no paid item is left.
  function enforce() {
    if (busy) return;
    getCart().then(function (cart) {
      var samples = cart.items.filter(isSample);
      if (!samples.length) return;
      var allowance = allowanceFor(cart);
      var kept = 0, updates = {}, changed = false;
      samples.forEach(function (s) {
        var keep = Math.max(0, Math.min(s.quantity, allowance - kept));
        if (keep !== s.quantity) { updates[s.variant_id] = keep; changed = true; }
        kept += keep;
      });
      if (!changed) return;
      busy = true;
      return update(updates).finally(function () { busy = false; });
    }).catch(function (e) { console.error('[samples]', e); });
  }

  var t;
  function scheduleEnforce() { clearTimeout(t); t = setTimeout(enforce, 400); }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sample-variant]');
    if (!btn) return;
    e.preventDefault();
    if (busy) return;
    busy = true;
    btn.setAttribute('aria-busy', 'true');
    var vid = Number(btn.getAttribute('data-sample-variant'));
    getCart()
      .then(function (cart) {
        var allowance = allowanceFor(cart);
        var samples = cart.items.filter(isSample);
        var updates = {};
        if (samples.some(function (i) { return i.variant_id === vid; })) {
          updates[vid] = 0; // second click removes it
        } else {
          var count = samples.reduce(function (s, i) { return s + i.quantity; }, 0);
          // Swap: drop the oldest selections until there is room (cart.js lists newest first).
          for (var k = samples.length - 1; k >= 0 && count >= allowance; k--) {
            updates[samples[k].variant_id] = 0;
            count -= samples[k].quantity;
          }
          if (allowance > 0) updates[vid] = 1;
        }
        return update(updates);
      })
      .catch(function (err) { console.error('[samples]', err); })
      .finally(function () { busy = false; btn.removeAttribute('aria-busy'); });
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleEnforce);
  }
  document.addEventListener('cart:updated', scheduleEnforce);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scheduleEnforce);
  else scheduleEnforce();
})();
